import InfoContainer from "./InfoContainer.jsx";
export default InfoContainer